import React from 'react'
import TextInput from '@peracto/peracto-editor-ui/dist/TextInput'
import Textarea from '@peracto/peracto-editor-ui/dist/Textarea'
import File from '@peracto/peracto-editor-ui/dist/File'
import Checkbox from '@peracto/peracto-editor-ui/dist/Checkbox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'

import { MIN_CARDS, MAX_CARDS, createDefaultCard } from '../constants'

const ImageCardsBlockForm = ({ onChange, state: { cards = [] } }) => {
    const updateCard = (index, field, value) => {
        const cardsClone = [...cards]
        cardsClone[index] = { ...cardsClone[index], [field]: value }
        onChange({ cards: cardsClone })
    }

    const removeCard = index => {
        const cardsClone = [...cards]
        cardsClone.splice(index, 1)
        onChange({ cards: cardsClone })
    }

    const addCard = () => {
        onChange({ cards: [...cards, createDefaultCard()] })
    }

    return (
        <>
            {cards.map((card, index) => (
                <div key={index}>
                    <p className="font-weight-bold mt-2 mb-1">{`Card ${index + 1}`}</p>

                    <File
                        label="Image"
                        onChange={value => updateCard(index, 'image', value)}
                        value={card.image}
                        isInline={false}
                        showThumbnail
                    />

                    <TextInput
                        label="Image alt text"
                        onChange={e => updateCard(index, 'imageAlt', e.target.value)}
                        value={card.imageAlt || ''}
                    />

                    <TextInput
                        label="Title"
                        onChange={e => updateCard(index, 'title', e.target.value)}
                        value={card.title || ''}
                    />

                    <Textarea
                        label="Copy"
                        onChange={(e, editor) => updateCard(index, 'copy', editor.getData())}
                        value={card.copy || ''}
                    />

                    <TextInput
                        label="Link text"
                        onChange={e => updateCard(index, 'linkText', e.target.value)}
                        value={card.linkText || ''}
                    />

                    <TextInput
                        label="Link URL"
                        onChange={e => updateCard(index, 'linkUrl', e.target.value)}
                        value={card.linkUrl || ''}
                    />

                    <Checkbox
                        label="Open in new tab"
                        checked={card.openInNewTab}
                        onChange={e => updateCard(index, 'openInNewTab', e.target.checked)}
                    />

                    {cards.length > MIN_CARDS && (
                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={() => removeCard(index)}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{' '}
                            {`Remove Card ${index + 1}`}
                        </button>
                    )}

                    <hr className="my-2" style={{ borderTop: '1px solid #666' }} />
                </div>
            ))}

            {cards.length < MAX_CARDS && (
                <button className="btn btn-sm btn-secondary w-100" onClick={addCard}>
                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add Card
                </button>
            )}
        </>
    )
}

export default ImageCardsBlockForm
